// @flow

import * as React from 'react';
import connectStatic from 'app/utils/connectStatic';
import t from 'app/utils/translate';
import Page from 'app/containers/parts/Page';
import StaticContent from 'app/components/static/StaticContent';

const AboutContent = connectStatic({
  index: 'about',
  title: t('About Us')
})(StaticContent);

function About() {
  return (
    <Page>
      <AboutContent />
    </Page>
  );
}

export default About;
